import { ITokenBuy, useRejectTokenBuyMutation } from '@entities/trades/token-buy';
import ModalConfirm from '@features/modal-confirm';
import { useModal } from '@shared/components/Modal';

interface IProps<T> {
  tokenBuy: T;
  refetch: () => void;
}

export const RejectTokenBuy = <T extends ITokenBuy>({ tokenBuy, refetch }: IProps<T>) => {
  const { id } = tokenBuy;

  const [rejectTokenBuy] = useRejectTokenBuyMutation();
  const { closeModal } = useModal();

  const handleConfirm = async () => {
    try {
      await rejectTokenBuy({ id }).unwrap();
      closeModal();
      refetch();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ModalConfirm
      title='Reject Token Buy'
      message='Do you want to reject this order?'
      onConfirm={handleConfirm}
      onCancel={closeModal}
    />
  );
};
